import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { themeSelector } from '@/state/config';
import styles from './Button.module.scss';
export const Button = ({ className, type = 'button', children, fullWidth = false, onClick, variant = 'primary', isLoading = false, }) => {
    const theme = useRecoilValue(themeSelector);
    return (_jsx("button", { className: cn(className, styles.button, styles[theme], styles[variant], {
            [styles.fullWidth]: fullWidth,
        }), type: type, tabIndex: 0, onClick: onClick ? onClick : undefined, children: isLoading ? _jsx(LoadingIcon, { variant: "light", size: "small" }) : children }));
};
